import React from "react"
import PropTypes from "prop-types"
import { Tag, Row, Col, Typography } from "antd"

const LABEL_LOADING = "Loading..."


const Title = ({ name, investmentId }) => {
  const title = !name
    ? <Typography.Text>{LABEL_LOADING}</Typography.Text>
    : (
      <Typography.Title level={5} style={{ margin: 0 }}>
        {name}
      </Typography.Title>
    )

  return (
    <Row>
      <Col flex="auto">{title}</Col>
      <Col>
        <Tag bordered={false}>
          {investmentId}
        </Tag>
      </Col>
    </Row>
  )
}

Title.propTypes = {
  name: PropTypes.string,
  investmentId: PropTypes.string
}

Title.defaultProps = {
  name: undefined,
  investmentId: ""
}

export default Title
